import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { ErrorService } from './error.service';

const mime = require('mime-types');

@Injectable()
export class FileService {

	constructor(private _http: HttpClient,
				private _errorService: ErrorService) {
	}

	convertToBlob(fileData, sliceSize = 512): Blob {
		const byteCharacters = atob(fileData.base64EncodedData);
		const byteArrays = [];
		for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
			const slice = byteCharacters.slice(offset, offset + sliceSize);
			const byteNumbers = new Array(slice.length);
			for (let i = 0; i < slice.length; i++) {
				byteNumbers[i] = slice.charCodeAt(i);
			}
			const byteArray = new Uint8Array(byteNumbers);
			byteArrays.push(byteArray);
		}
		return new Blob(byteArrays, {type: mime.lookup(fileData.fileName)});
	}

	/**
	 * @api {delete} /v2/Files/:id Delete File
	 * @apiName deleteFile
	 * @apiGroup Files
	 * @apiVersion 20.0.0
	 */
	deleteFile(id) {
		return this._http.delete<any>(`${environment.apiUrl}/v2/Files/${id}`);
	}

	getDisallowedExtensions() {
		return [
			'.ADE', '.ADP', '.BAT', '.CHM', '.CMD', '.COM', '.CPL', '.EXE', '.HTA', '.INS', '.ISP', '.JAR', '.JS', '.JSE',
			'.LIB', '.LNK', '.MDE', '.MSC', '.MSI', '.MSP', '.MST', '.NSH', '.PIF', '.SCR', '.SCT', '.SHB', '.SYS', '.VB',
			'.VBE', '.VBS', '.VXD', '.WSC', '.WSF', '.WSH'
		];
	}

	/**
	 * @api {get} /v2/Files/:id Get File
	 * @apiName getFile
	 * @apiParam {string} [convertTo] Conversion Format
	 * @apiGroup Files
	 * @apiVersion 20.0.0
	 */
	getFile(id, convertTo) {
		let params: HttpParams = new HttpParams();
		params = params.append('convertTo', convertTo);
		return this._http.get<any>(`${environment.apiUrl}/v2/Files/${id}`, {params});
	}

	/**
	 * @api {get} /v2/Files/:type/:id Get Files By Type
	 * @apiName getFilesByParentId
	 * @apiGroup Files
	 * @apiVersion 20.0.0
	 */
	getFilesByParentId(type, id) {
		return this._http.get<any>(`${environment.apiUrl}/v2/Files/${type}/${id}`);
	}

	openFileNewWindow(file) {
		const fileURL = URL.createObjectURL(file);
		const newWindow = window.open(fileURL, '_blank');
		if (!newWindow || newWindow.closed || typeof newWindow.closed == 'undefined') {
			this._errorService.error({
				detailedMsg: 'Pop-up Blocker is enabled! Please add this site to your exception list.',
				generalMsg: 'Pop-up blocked!'
			}, null, 'modal');
		}
		newWindow.onload = () => {
			newWindow.focus();
			newWindow.print();
		};
	}

	/**
	 * @api {post} /v2/Files Upload File
	 * @apiName uploadFile
	 * @apiGroup Files
	 * @apiVersion 20.0.0
	 */
	uploadFile(fileData) {
		return this._http.post<any>(`${environment.apiUrl}/v2/Files`, fileData);
	}
}
